import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Components
import Header from "./Components/header";
import ImageCarousel from "./Components/carousel";
import TitleText from "./Components/titleText";
import WhatWeDo from "./Components/whatwedo";
import HalfSectionMobile from "./Components/halfSectionMobile";
import HalfSectionWeb from "./Components/halfSectionWeb";
import Process from "./Components/process";
import Pricing from "./Components/pricing";
import Product from "./Components/product";
import How from "./Components/seeHow";
import Items from "./Components/items";
import VideoFront from "./Components/videoFront";
import ItemsImages from "./Components/itemsImages";
import Affordable from "./Components/affordable";
import Vancouver from "./Components/titleVancouver";
import Projects from "./Components/projects";

// Pages
import Contact from "./Pages/contact";
import Ordering from "./Pages/onlineOrdering";

// Bootstrap & CSS
import Container from "react-bootstrap/Container";
import Footer from "./Components/footer";
import AOS from "aos";
import "./App.css";
import "./CSS/front.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const Home = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // useEffect(() => {

  //   setOpen(true);
  // }, [])

  return (
    <div>
      <Header />
      <VideoFront />
      <TitleText />

      <div style={{ marginTop: "100vh" }}>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2
                id="transition-modal-title"
                style={{ fontFamily: "poppins", fontWeight: 800 }}
              >
                Website is being updates
              </h2>
              <p
                id="transition-modal-description"
                style={{ fontFamily: "poppins", fontWeight: 500 }}
              >
                The Compile Labs website is undergoing major changes, we'll keep
                you updated. Thank you for visiting us!
              </p>
            </div>
          </Fade>
        </Modal>
        <How />

        <WhatWeDo />

        <Container>
          <Row>
            <Col md={12}>
              <ItemsImages />
            </Col>
          </Row>
        </Container>
        <Projects />
        <Process />
        <HalfSectionMobile />
        <HalfSectionWeb />
        {/* <Container>
          <Pricing />
          <Affordable />
        </Container> */}
        <Product />
      </div>
    </div>
  );
};

const HomeVancouver = () => {
  return (
    <div>
      <Header />
      <VideoFront />
      <Vancouver />
      <div style={{ marginTop: "100vh" }}>
        <How />

        <Container>
          <Row>
            <Col md={8} class="text-center">
              <WhatWeDo />
            </Col>
            <Col md={12}>
              <ItemsImages />
            </Col>
          </Row>
        </Container>

        <Process />
        <HalfSectionMobile />
        <HalfSectionWeb />
        <Container>
          <Pricing />
          <Affordable />
        </Container>
        <Product />
      </div>
    </div>
  );
};

class App extends React.Component {
  componentDidMount() {
    AOS.init({
      duration: 1000,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div>
        <Switch>
          <Route path="/" exact component={Home} />

          <Route path="/app-development-vancouver" component={HomeVancouver} />

          <Route path="/contact" component={Contact} />
          <Route path="/orderingapp" component={Ordering} />
        </Switch>

        <Footer />
      </div>
    );
  }
}

export default App;
